import React, { useState, useEffect } from 'react';
import MagneticButton from '../Miscellaneous/MagneticButton';
import { fetchAPI, getStrapiMedia } from '../../utils/api';

const Hero = () => {
    const [heroData, setHeroData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getData = async () => {
            try {
                const hero = await fetchAPI('/hero', {
                });
                if (hero.data) {
                    setHeroData(hero.data);
                }
            } catch (error) {
                console.error("Error fetching hero data:", error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, []);

    if (loading) return null; // Or a loader
    if (!heroData) return null;

    return (
        <section id="home" className="hero-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {/* Hero Content */}
                        <div className="hero-content">
                            <span className="intro-text">{heroData.introText}</span>
                            <h1 className="title section-title mt-3 mt-md-4 mb-md-5">
                                {heroData.title} <span>{heroData.highlightedText}</span>
                            </h1>

                            {/* Content */}
                            <div className="content d-flex flex-column flex-md-row justify-content-md-between mb-5">
                                <div className="hero-button order-last order-md-first mt-4 mt-md-0">
                                    <MagneticButton
                                        href={heroData.buttonLink || "/contact"}
                                    >
                                        {heroData.buttonText || "Get Involved"}
                                    </MagneticButton>
                                </div>
                                <p className="sub-title order-first order-md-last">{heroData.subtitle}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="hero-bg">
                {heroData.backgroundImage && (
                    <img className="circle-1" src={getStrapiMedia(heroData.backgroundImage)} alt="Background" />
                )}
            </div>
        </section>
    );
};


export default Hero;
